import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from 'react';
import React, { Suspense } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { Error } from "./components/error/error";
//redux components
import { connect } from "react-redux";
import { actions } from "./redux/actions/Translation.action";
import { Dispatch } from 'redux';
//Layouts
import SpecialLayout from "./layouts/SpecialLayout";
//to create theme
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material'
import useSettings from './hooks/useSettings'
import { createCustomTheme } from './theme'

function App({ getTranslation, themeChoice, lightTheme, darkTheme, property }: { getTranslation: any, themeChoice: string, lightTheme: any, darkTheme: any, property: any }) {
  const { settings } = useSettings()
  const theme = createCustomTheme({
    direction: settings.direction === 'rtl' ? 'rtl' : 'ltr',
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: `${themeChoice}`,
    lightTheme: lightTheme,
    darkTheme: darkTheme,
    property: property,
  })

  useEffect(() => { getTranslation() }, [])

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <CssBaseline />
        <Suspense fallback={
          <div className="loader-wrapper">
            <CircularProgress color="primary" size={70} />
            <Typography variant="body1" className="loader-text"> Loading..</Typography>
          </div>}>
          <Routes>
            <Route path="/*" element={<SpecialLayout headerHidden={false} />} />
            <Route path="/*" element={<Error />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
}
const mapStateToProps = (state: any) => ({
  themeChoice: state.themeSwitch.themeChoice,
  lightTheme: state.themeSwitch.lightTheme,
  darkTheme: state.themeSwitch.darkTheme,
  property: state.themeSwitch.theme
});
const mapDispatchToProps = (dispatch: Dispatch<any>) => ({ getTranslation: () => { dispatch(actions.getTranslation()); }, });
export default connect(mapStateToProps, mapDispatchToProps)(App);